import _ from 'lodash';
import React from 'react';
import {formValueSelector} from 'redux-form';

import Label from 'components/Label';
import Warning from 'components/Warning';
import FormField from 'components/FormField';
import ErrorBlock from 'components/ErrorBlock';
import {SearchRoomField} from 'components/Fields';
import {buildRoomSelectizeOption} from 'components/Fields/SearchRoomField';

import {selectModal, MODALS as BASE_MODALS} from 'ducks/modals';

import {headOption} from 'utils/common';

const NO_AVAILABLE_ROOMS_ERROR =
  'There are no available rooms of this type for the selected dates';

const DIFFERENT_ROOM_FROM_SELECTED_BOOKING_ROOM_WARNING =
  "You have selected different room number to the member's current room type!";

const ROOM_PURPOSE_TYPE_DOES_NOT_CORRESPOND_TO_THE_SELECTED_BOOKING_TYPE =
  'Selected room has purpose type that does not correspond to the selected booking type!';

const formSelector = formValueSelector('createBookingExtension');

export const initialValues = state => {
  const modal = selectModal(state, BASE_MODALS.CREATE_BOOKING);

  const unorderedAvailableRooms = _.get(
    modal,
    'data.bookingExtensionAvailableRooms',
    []
  );

  const selectedBooking = formSelector(state, 'booking');
  // Order rooms only if booking has been selected in order preventing error when removing selected booking
  const availableRooms =
    selectedBooking &&
    _.orderBy(
      unorderedAvailableRooms,
      room => room.id === selectedBooking.object.room.id,
      'desc'
    );

  const selectedAvailableRoom = headOption(
    availableRooms,
    buildRoomSelectizeOption
  );

  return {
    room: selectedAvailableRoom
  };
};

const RoomSection = ({
  availableRooms,
  noAvailableRooms,
  differentRoom,
  hasNotMatchingRoomPurposeToBookingType,
  roomAvailabilityMessage,
  availableRoomsAreLoading
}) => (
  <div>
    <FormField>
      <Label>Room</Label>
      <SearchRoomField
        rooms={availableRooms}
        isLoading={availableRoomsAreLoading}
      />
    </FormField>
    {differentRoom && (
      <Warning>{DIFFERENT_ROOM_FROM_SELECTED_BOOKING_ROOM_WARNING}</Warning>
    )}
    {hasNotMatchingRoomPurposeToBookingType && (
      <Warning>
        {ROOM_PURPOSE_TYPE_DOES_NOT_CORRESPOND_TO_THE_SELECTED_BOOKING_TYPE}
      </Warning>
    )}
    {roomAvailabilityMessage && (
      <div className="roomAvailabilityMessage">{roomAvailabilityMessage}</div>
    )}
    {noAvailableRooms && <ErrorBlock>{NO_AVAILABLE_ROOMS_ERROR}</ErrorBlock>}
  </div>
);

export default RoomSection;
